/**
 * Gibraltar pound.
 */
export var GIP = {
  code: 'GIP',
  base: 10,
  exponent: 2
};